// ====================================
// DESIGN SYSTEM J-O-H
// ====================================
// REGOLA: OGNI NUOVO COMPONENTE DEVE USARE QUESTE VARIABILI
// Non usare mai valori hardcoded - sempre riferimento a questo file

export const designSystem = {
  // ===== COLORI PRIMARI =====
  colors: {
    primary: {
      main: '#0d9488',      // Teal principale - bottoni, link, accenti
      light: '#14b8a6',     // Teal chiaro - hover states
      dark: '#0f766e',      // Teal scuro - focus states
      50: '#0d948810',      // Background molto trasparente
      100: '#0d948820',     // Background trasparente
      500: '#0d9488',       // Standard
      600: '#0d9488',       // Intenso
      700: '#0f766e',       // Scuro
    },
    
    secondary: {
      main: '#A0A0A0',      // Grigio come nel sito
      light: '#D0D0D0',     // Grigio chiaro come nel sito
      dark: '#555555',      // Grigio scuro come nel sito
    },
    
    background: {
      primary: '#0A0A0A',    // Sfondo principale - NERO come nel sito
      secondary: '#121212',  // Sfondo sezioni - GRIGIO SCURO come nel sito
      tertiary: '#1a1a1a',  // Sfondo card - un po' più chiaro
      gradient: 'linear-gradient(135deg, #0d9488 0%, #14b8a6 100%)', // Gradient principale
      heroGradient: 'linear-gradient(135deg, rgba(13, 148, 136, 0.9) 0%, rgba(20, 184, 166, 0.9) 100%)',
      darkOverlay: 'linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.5) 100%)',
      cardOverlay: 'rgba(10, 10, 10, 0.7)', // Come nel sito
    },
    
    text: {
      primary: '#F5F5F5',    // Testo principale - BIANCO come nel sito
      secondary: '#A0A0A0',  // Testo secondario - GRIGIO come nel sito
      light: '#D0D0D0',      // Testo chiaro - GRIGIO CHIARO come nel sito
      white: '#ffffff',      // Testo bianco
      muted: '#808080',      // Testo sfumato
    },
    
    status: {
      success: '#22c55e',    // Verde successo
      error: '#ef4444',      // Rosso errore
      warning: '#f59e0b',    // Arancione warning
      info: '#3b82f6',       // Blu info
    },
    
    border: {
      light: '#555555',      // Bordi chiari - GRIGIO SCURO come nel sito
      medium: '#333333',     // Bordi medi
      dark: '#222222',       // Bordi scuri
    }
  },

  // ===== TIPOGRAFIA =====
  typography: {
    fontFamily: {
      primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
      secondary: "'Playfair Display', Georgia, serif", // Per titoli eleganti
    },
    
    fontSize: {
      xs: '0.75rem',      // 12px
      sm: '0.875rem',     // 14px
      base: '1rem',       // 16px
      lg: '1.125rem',     // 18px
      xl: '1.25rem',      // 20px
      '2xl': '1.5rem',    // 24px
      '3xl': '1.875rem',  // 30px
      '4xl': '2.25rem',   // 36px
      '5xl': '3rem',      // 48px
      '6xl': '3.75rem',   // 60px
    },
    
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
    },
    
    lineHeight: {
      tight: 1.25,
      normal: 1.5,
      relaxed: 1.75,
    }
  },

  // ===== SPAZIATURE =====
  spacing: {
    xs: '0.5rem',    // 8px
    sm: '0.75rem',   // 12px
    md: '1rem',      // 16px
    lg: '1.5rem',    // 24px
    xl: '2rem',      // 32px
    '2xl': '2.5rem', // 40px
    '3xl': '3rem',   // 48px
    '4xl': '4rem',   // 64px
    '5xl': '5rem',   // 80px
    '6xl': '6rem',   // 96px
  },

  // ===== BREAKPOINTS =====
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
    ultrawide: '1440px',
  },

  // ===== OMBRE =====
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    card: '0 4px 20px rgba(0, 0, 0, 0.1)',
    hover: '0 8px 30px rgba(13, 148, 136, 0.2)',
  },

  // ===== RADIUS =====
  borderRadius: {
    none: '0',
    sm: '0.25rem',   // 4px
    md: '0.5rem',    // 8px
    lg: '0.75rem',   // 12px
    xl: '1rem',      // 16px
    '2xl': '1.5rem', // 24px
    full: '9999px',  // Cerchio completo
  },

  // ===== TRANSIZIONI =====
  transitions: {
    fast: '0.15s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
    spring: '0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },

  // ===== Z-INDEX =====
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modal: 1040,
    popover: 1050,
    tooltip: 1060,
  },

  // ===== LAYOUT =====
  layout: {
    containerMaxWidth: '1200px',
    sectionPadding: '5rem 0',
    sectionPaddingMobile: '3rem 0',
    headerHeight: '80px',
    footerHeight: '300px',
  }
};

// ===== COMPONENTI STYLED COMUNI =====
export const commonStyles = {
  // Container principale
  container: `
    max-width: ${designSystem.layout.containerMaxWidth};
    margin: 0 auto;
    padding: 0 ${designSystem.spacing.lg};
    
    @media (max-width: ${designSystem.breakpoints.tablet}) {
      padding: 0 ${designSystem.spacing.md};
    }
  `,
  
  // Sezione standard
  section: `
    padding: ${designSystem.layout.sectionPadding};
    
    @media (max-width: ${designSystem.breakpoints.tablet}) {
      padding: ${designSystem.layout.sectionPaddingMobile};
    }
  `,
  
  // Card standard
  card: `
    background: ${designSystem.colors.background.tertiary};
    border-radius: ${designSystem.borderRadius.xl};
    box-shadow: ${designSystem.shadows.card};
    padding: ${designSystem.spacing.xl};
    border: 1px solid ${designSystem.colors.border.light};
    transition: all ${designSystem.transitions.normal};
    
    &:hover {
      box-shadow: ${designSystem.shadows.hover};
      transform: translateY(-2px);
    }
  `,
  
  // Bottone primario
  buttonPrimary: `
    background: ${designSystem.colors.background.gradient};
    color: ${designSystem.colors.text.white};
    border: none;
    border-radius: ${designSystem.borderRadius.lg};
    padding: ${designSystem.spacing.md} ${designSystem.spacing.xl};
    font-weight: ${designSystem.typography.fontWeight.semibold};
    font-size: ${designSystem.typography.fontSize.base};
    cursor: pointer;
    transition: all ${designSystem.transitions.normal};
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${designSystem.spacing.sm};
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: ${designSystem.shadows.hover};
    }
    
    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }
  `,
  
  // Bottone secondario
  buttonSecondary: `
    background: transparent;
    color: ${designSystem.colors.primary.main};
    border: 2px solid ${designSystem.colors.primary.main};
    border-radius: ${designSystem.borderRadius.lg};
    padding: ${designSystem.spacing.md} ${designSystem.spacing.xl};
    font-weight: ${designSystem.typography.fontWeight.semibold};
    font-size: ${designSystem.typography.fontSize.base};
    cursor: pointer;
    transition: all ${designSystem.transitions.normal};
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: ${designSystem.spacing.sm};
    
    &:hover {
      background: ${designSystem.colors.primary.main};
      color: ${designSystem.colors.text.white};
      transform: translateY(-2px);
    }
  `,
  
  // Input standard
  input: `
    width: 100%;
    padding: ${designSystem.spacing.md};
    border: 2px solid ${designSystem.colors.border.light};
    border-radius: ${designSystem.borderRadius.lg};
    font-size: ${designSystem.typography.fontSize.base};
    font-family: ${designSystem.typography.fontFamily.primary};
    transition: all ${designSystem.transitions.normal};
    background: ${designSystem.colors.background.secondary};
    color: ${designSystem.colors.text.primary};
    
    &:focus {
      outline: none;
      border-color: ${designSystem.colors.primary.main};
      box-shadow: 0 0 0 3px ${designSystem.colors.primary.main}20;
    }
    
    &::placeholder {
      color: ${designSystem.colors.text.secondary};
    }
  `,
  
  // Titolo principale
  titlePrimary: `
    font-family: ${designSystem.typography.fontFamily.secondary};
    font-size: ${designSystem.typography.fontSize['4xl']};
    font-weight: ${designSystem.typography.fontWeight.bold};
    color: ${designSystem.colors.text.primary};
    line-height: ${designSystem.typography.lineHeight.tight};
    margin-bottom: ${designSystem.spacing.lg};
    
    @media (max-width: ${designSystem.breakpoints.tablet}) {
      font-size: ${designSystem.typography.fontSize['3xl']};
    }
  `,
  
  // Titolo secondario
  titleSecondary: `
    font-family: ${designSystem.typography.fontFamily.primary};
    font-size: ${designSystem.typography.fontSize['2xl']};
    font-weight: ${designSystem.typography.fontWeight.semibold};
    color: ${designSystem.colors.text.primary};
    margin-bottom: ${designSystem.spacing.md};
  `,
  
  // Titolo grande
  titleLarge: `
    font-family: ${designSystem.typography.fontFamily.secondary};
    font-size: ${designSystem.typography.fontSize['3xl']};
    font-weight: ${designSystem.typography.fontWeight.bold};
    color: ${designSystem.colors.text.primary};
    line-height: ${designSystem.typography.lineHeight.tight};
    margin-bottom: ${designSystem.spacing.lg};
    
    @media (max-width: ${designSystem.breakpoints.tablet}) {
      font-size: ${designSystem.typography.fontSize['2xl']};
    }
  `,
  
  // Titolo medio
  titleMedium: `
    font-family: ${designSystem.typography.fontFamily.primary};
    font-size: ${designSystem.typography.fontSize.xl};
    font-weight: ${designSystem.typography.fontWeight.semibold};
    color: ${designSystem.colors.text.primary};
    margin-bottom: ${designSystem.spacing.md};
  `,
  
  // Testo body
  bodyText: `
    font-family: ${designSystem.typography.fontFamily.primary};
    font-size: ${designSystem.typography.fontSize.base};
    color: ${designSystem.colors.text.secondary};
    line-height: ${designSystem.typography.lineHeight.relaxed};
    margin-bottom: ${designSystem.spacing.md};
  `,
  
  // Grid responsive
  gridResponsive: `
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: ${designSystem.spacing.xl};
    
    @media (max-width: ${designSystem.breakpoints.tablet}) {
      grid-template-columns: 1fr;
      gap: ${designSystem.spacing.lg};
    }
  `,
  
  // Flex center
  flexCenter: `
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  
  // Gradient text
  gradientText: `
    background: ${designSystem.colors.background.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  `,
  
  // Loading animation
  loading: `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    animation: spin 1s linear infinite;
  `,
  
  // Fade in animation
  fadeIn: `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    
    animation: fadeIn 0.6s ease-out;
  `
};

// ===== UTILITIES =====
export const utils = {
  // Media queries helper
  media: {
    mobile: `@media (max-width: ${designSystem.breakpoints.mobile})`,
    tablet: `@media (max-width: ${designSystem.breakpoints.tablet})`,
    desktop: `@media (min-width: ${designSystem.breakpoints.desktop})`,
    wide: `@media (min-width: ${designSystem.breakpoints.wide})`,
  },
  
  // Spacing helper
  spacing: (size: keyof typeof designSystem.spacing) => designSystem.spacing[size],
  
  // Color helper
  color: (path: string) => {
    const keys = path.split('.');
    let value: any = designSystem.colors;
    for (const key of keys) {
      value = value[key];
    }
    return value;
  }
};

export default designSystem; 